import { ChangeDetectorRef, Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { RoleServiceService } from '../../../utilities/services/role-service/role-service.service';
import { DashboardService } from '../../../utilities/services/dashboard-service/dashboard.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgOtpInputModule } from 'ng-otp-input';
import { AuthServiceService } from '../../../utilities/services/auth-service/auth-service.service';
import { EncryptDecryptService } from '../../../utilities/services/EncrptyDecrypt/encrypt-decrypt.service';
import { CommonServiceService } from '../../../utilities/services/common-service/common-service.service';
import { Subject, takeUntil } from 'rxjs';
import { DropdownModule } from 'primeng/dropdown';
import { ThemeServiceService } from '../../../utilities/services/theme-service.service';

import { environment } from '../../../../environments/environment';
import {
  extractAccessTokenFromAuthBody,
  readAuthProfileFlags,
} from '../../../utilities/auth-payload.util';
import { reloadAfterNavigation } from '../../../utilities/auth-session.util';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DropdownModule, MatLabel, MatSelect, MatOption, MatInput,
    OverlayModule, NgOtpInputModule, TranslateModule,],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})
export class SignupComponent  implements OnInit, OnDestroy {
  logo_dark: string = environment.logo_dark;
  logo_light: string = environment.logo_light;

  /** Light-theme logo in signup sidebar; TTNZ uses `login_sidebar_logo_light` from env. */
  get loginSidebarLogoLight(): string {
    const env = environment as typeof environment & {
      login_sidebar_logo_light?: string;
    };
    if (env.tenant_Name === 'spain' || env.tenant_Name === 'ptta') {
      return env.logo;
    }
    return env.login_sidebar_logo_light ?? env.logo_dark;
  }

  tenant_name: string = environment.tenant_Name;
  // Terms URL (only use explicit term_conditions_url or other explicit keys; do NOT fallback to website_url)
  public termsUrl: string = (environment as any)?.term_conditions_url || (environment as any)?.termsAndConditionsUrl || (environment as any)?.terms_url || (environment as any)?.termsUrl || '';
  // Whether user has accepted terms and conditions
  public acceptedTerms: boolean = false;
  _selectedRole: any
  _roles: any = [];
  _email: any = '';
  _password: any = null;
  all_roles: any = []
  total_fields: any = [] // storing  fields who have access to login
  login_data: any = []
  _formGroupDynamic!: FormGroup;
  _isSubmit: boolean = false
  is_password: boolean = false
  input_type: string = "password"
  password_field: {} =
    {
      "role_id": 1,
      "id": "password",
      "is_login": true,
      "is_required": true,
      "is_deleted": false,
      "updated_by": null,
      "field_id": "password",
      "field": {
        "name": "Password",
        "id": "password",
        "value_json": {

        },
        "type": "password"
      }
    };
  _responseData: any = [];
  forget_password: boolean = false;
  fetched_role_id: number = 0;
  _selectedBanner: any = '';
  _uploadImage: any;
  _showLoader: boolean = false;
  is_view: boolean = false;
  _current_role_id: number = 0
  roleParentData: any = []
  selectedParentData: any = {};
  pasword_type_list = [
    { title: "8 characters long" },
    { title: "Include both uppercase and lowercase letters" },
    { title: "One number" },
    { title: "One special character (e.g., !, @, #, $)'." },
  ]
  isOpen: boolean = false
  valid_form: boolean = false
  activeIndex: any = 0;
  _currentOTP: any = '';
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: false,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '17%',
      height: '40px',
    },
  };
  timer: any = '';
  readonly otpTimerDuration = 180;
  _startCountdown: boolean = false;
  _isResendingOtp = false;
  intervalId: number = 0;
  role_field_id: number = 0;
  emailValue: any = ''
  is_dark: boolean = false;
  showAccountExistsDialog: boolean = false;
  footerSupportEmail: string = '';
  private readonly destroy$ = new Subject<void>();
  screenWidth: number = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = globalThis.window.innerWidth;
  }
  constructor(private readonly roleService: RoleServiceService, private readonly commonService: CommonServiceService,
    private readonly zone: NgZone,
    private readonly cd: ChangeDetectorRef,
    private readonly fb: FormBuilder, private readonly router: Router, private readonly authService: AuthServiceService,
    public readonly dashboardService: DashboardService, private readonly encryptDecryptService: EncryptDecryptService, private readonly themeService: ThemeServiceService, private readonly translateService: TranslateService) {
    if (globalThis.window !== undefined) {
      (globalThis as any).TERMS_URL = this.termsUrl;
      this.screenWidth = globalThis.window.innerWidth;
    }
  }
  // Expose a safe getter for template to read the terms URL (prefers globalThis.window.TERMS_URL if set)
  public get globalTermsUrl(): string {
    let url = '';
    if (globalThis.window !== undefined && (globalThis.window as any).TERMS_URL) {
      url = (globalThis.window as any).TERMS_URL;
    } else {
      url = this.termsUrl;
    }
    return (url || '').toString().trim();
  }
  // Whether terms acceptance is required (true only when a non-empty URL is configured)
  public get isTermsRequired(): boolean {
    return !!this.globalTermsUrl;
  }

  // Centralized disabled logic for the signup button
  public get isSignupDisabled(): boolean {
    // preserve previous valid_form behavior
    if (this.valid_form) {
      return true;
    }
    // If terms are required and not accepted, disable
    if (this.isTermsRequired && !this.acceptedTerms) {
      return true;
    }
    // also disable if form group exists and is invalid
    if (this._formGroupDynamic?.invalid) {
      return true;
    }
    return false;
  }
  ngOnInit() {
    this._formGroupDynamic = this.fb.group({});
    this.commonService.getFooterConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.footerSupportEmail = res?.data?.info_config?.email || '';
        },
        error: () => undefined,
      });
    this.themeService.isDark$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDark: boolean) => {
        this.is_dark = isDark;
        this.cd.detectChanges();
      });

    // Initialize theme value
    this.is_dark = this.themeService.getTheme();
    this.getRoles()
  }



  // Password validation methods
  isPasswordLengthValid(): boolean {
    const password = this._formGroupDynamic.get('password')?.value;
    return password && password.length >= 8;
  }

  isPasswordUppercaseValid(): boolean {
    const password = this._formGroupDynamic.get('password')?.value;
    return password && /[A-Z]/.test(password);
  }

  isPasswordNumberValid(): boolean {
    const password = this._formGroupDynamic.get('password')?.value;
    return password && /\d/.test(password);
  }

  isPasswordSpecialValid(): boolean {
    const password = this._formGroupDynamic.get('password')?.value;
    return password && /[!@#$%^&*.,:;]/.test(password);
  }

  isPasswordMatch(): boolean {
    const password = this._formGroupDynamic.get('password')?.value;
    const confirmPassword = this._formGroupDynamic.get('Confirm_password')?.value;
    return password && confirmPassword && password === confirmPassword;
  }

  isAllPasswordCriteriaMet(): boolean {
    return this.isPasswordLengthValid() &&
      this.isPasswordUppercaseValid() &&
      this.isPasswordNumberValid() &&
      this.isPasswordSpecialValid();
  }

  togglePasswordVisibility() {
    this.input_type = this.input_type === 'password' ? 'text' : 'password';
  }

  // Get Total roles
  getRoles(customParams: any = {}) {
    const {
      role_ids = 0,
      page_num = 0,
      per_page = 0,
      join_verifiers = false,
      join_parents = false,
      role_fields = false,
      is_active = true,
      is_login = false,
      source = 'signup'
    } = customParams;
    this.roleService.getRoles(role_ids,
      page_num,
      per_page,
      join_verifiers,
      join_parents,
      role_fields,
      is_active,
      is_login,
      source).subscribe({
        next: (req: any) => {
          if (req.code == 200) {
            this.all_roles = req.data?.roles.filter((x: any) => x.is_active)

          }
          this.valid_form = true
        },
        error: (error) => {
          console.error('Error creating role', error);
        },
        complete: () => {
          this._isSubmit = false;
        }
      });
  }

  // get role felds based on Role Id
  GetRoleFieldsOnId(data: any) {
    this._current_role_id = data.value.id
    this.fetched_role_id = this.all_roles.filter(
      (x: any) => x.id == data.value.id
    )[0].id;
    if (globalThis.window?.sessionStorage) {
      sessionStorage.setItem('fetched_role_id', this.fetched_role_id.toString());
    }
    this.roleService.getRoleFields(this.fetched_role_id).subscribe({
      next: (req: any) => {
        this.total_fields = []
        if (req.code == 200) {
          this.total_fields = req.data.data[1]
          this.total_fields = this.total_fields.filter((x: any) => x.is_login && x.is_required)
          this.total_fields.push(this.password_field)
          this.total_fields.push({
            "role_id": 2,
            "id": "Confirm_password",
            "is_login": true,
            "is_required": true,
            "is_deleted": false,
            "updated_by": null,
            "field_id": "Confirm_password",
            "field": {
              "name": "Confirm_password",
              "id": "Confirm_password",
              "value_json": {

              },
              "type": "password"
            }
          })
          for (const field of this.total_fields) {
            field.value = '';
            field.dummy_value = ''
            field.show_suggest = false
            field.show_password = false
          }
          if (globalThis.window?.sessionStorage) {
            sessionStorage.setItem('role_field_id', this.total_fields[0]?.id.toString());
          }
          this.valid_form = false
          this.constrolsFormDynamically(this.total_fields);


        }
      },
      error: (error) => {
        console.error('Error creating role', error);
      },
      complete: () => {
        //this.get_role_parents(this._current_role_id)
      }
    });

  }



  //create dynamic form validations
  constrolsFormDynamically(listOfFields: any) {
    const group: any = {};
    for (const item of listOfFields) {
      if (item.field.type == 'text') {
        group[item.field_id] = new FormControl('', []);
      } else if (item.field.type == 'number') {
        group[item.field_id] = new FormControl('', []);
      } else if (item.field.type == 'file') {
        group[item.field_id] = new FormControl('', []);
      } else if (item.field.type == 'email') {
        this.role_field_id = item.id;
        group[item.field_id] = new FormControl('', []);
      } else if (item.field.type == 'password') {

        group[item.field_id] = new FormControl('', Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*.,:;])(?=.{8,})/
          ),
        ]));
      } else if (item.field.type == 'alphanum') {
        group[item.field_id] = new FormControl('', []);
      } else if (item.field.type == 'dropdown') {
        group[item.field_id] = new FormControl('', []);
      } else if (item.field.type == 'date') {
        group[item.field_id] = new FormControl('', []);
      } else if (item.field.type == 'phone') {
        group[item.field_id] = new FormControl('', []);
      } else {
        group[item.field_id] = new FormControl('', []);
      }
    }
    this._formGroupDynamic = new FormGroup(group);
    this.setValidation(listOfFields);
  }
  //#endregion Here we are dynamically generating form controlsName with Json Data base on Role select
  //#region  With Help of this method we are genetrating validation dynamicaly as per our requirement
  setValidation(controlNames: any) {
    for (const item of controlNames) {
      this.applyDynamicFieldValidation(item);
    }
  }

  applyDynamicFieldValidation(item: any) {
    const validationHandlers: Record<string, (fieldItem: any) => void> = {
      text: (fieldItem) => this.applyRequiredTextValidation(fieldItem),
      number: (fieldItem) => this.applyRequiredOrClearFieldValidation(fieldItem),
      phone: (fieldItem) => this.applyRequiredOrClearFieldValidation(fieldItem),
      email: (fieldItem) => this.applyEmailFieldValidation(fieldItem),
      alphanum: (fieldItem) => this.applyAlphanumFieldValidation(fieldItem),
      password: (fieldItem) => this.applyPasswordFieldValidation(fieldItem),
    };
    validationHandlers[item.field.type]?.(item);
  }

  applyRequiredTextValidation(item: any) {
    if (item.is_required) {
      this.setDynamicControlValidators(item.field_id, Validators.required);
    }
  }

  applyRequiredOrClearFieldValidation(item: any) {
    if (item.is_required) {
      this.setDynamicControlValidators(item.field_id, Validators.required);
    } else {
      this.clearDynamicControlValidators(item.field_id);
    }
  }

  applyEmailFieldValidation(item: any) {
    if (item.is_required) {
      this.setDynamicControlValidators(item.field_id, Validators.compose([
        Validators.required,
        Validators.pattern(
          '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'
        ),
      ]));
    } else {
      this.clearDynamicControlValidators(item.field_id);
    }
  }

  applyAlphanumFieldValidation(item: any) {
    const validators = item.is_required
      ? Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')])
      : Validators.pattern('^[a-zA-Z0-9]*$');
    this.setDynamicControlValidators(item.field_id, validators);
  }

  applyPasswordFieldValidation(item: any) {
    if (item.is_required) {
      // password validators are set in constrolsFormDynamically
      return;
    }
    this.clearDynamicControlValidators(item.field_id);
  }

  setDynamicControlValidators(fieldId: any, validators: any) {
    this._formGroupDynamic.controls[fieldId]?.setValidators(validators);
    this._formGroupDynamic.controls[fieldId]?.updateValueAndValidity();
  }

  clearDynamicControlValidators(fieldId: any) {
    this._formGroupDynamic.controls[fieldId]?.setErrors(null);
    this._formGroupDynamic.controls[fieldId]?.clearValidators();
    this._formGroupDynamic.controls[fieldId]?.updateValueAndValidity();
  }

  showPassword(type: any, index: any) {
    this.is_password = type === "password";
    this.input_type = this.is_password ? 'text' : 'password';
    //   field.show_password = (i === index);
    // });
    this.total_fields.forEach((field: any, i: any) => {
      if (i === index) {
        field.show_password = !field.show_password; // Toggle the show_password property
      } else {
        field.show_password = false; // Optionally hide other password fields
      }
    });
  }

  closeDialog() {
    this.commonService.login_subject.next(false);
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('redirectAfterLogin');
      sessionStorage.removeItem('redirectSource');
    }
  }

  navigateToFrgt() {
    this.commonService.login_subject.next(true);
  }

  verifyOtpSignup() {

    if (this._formGroupDynamic.valid) {
      let _user_role_fields: any = []
      for (const field of this.total_fields) {
        if (field.id != 'password' && field.id != 'Confirm_password') {
          _user_role_fields.push({
            "role_field_id": field.id,
            "value": this._formGroupDynamic.controls[field.field_id].value
          })
        }
      }
      const body = {
        "otp": {
          "email": this.emailValue,
          "code": this._currentOTP
        },
        "user_role_data": {
          "password": this._formGroupDynamic.controls['password'].value,
          "user_role": {
            "user_id": 0,
            "role_id": this._current_role_id,
            "login_role_field_id": this.role_field_id,
            "login_role_field_value": this.emailValue
          },
          "user_role_fields": _user_role_fields,

        }
      }
      this.authService.verifysignupOtp(body).subscribe({
        next: (result: any) => {
          ; // Verify signup OTP API response
          this._formGroupDynamic.controls['password'].updateValueAndValidity();
          const accessToken = extractAccessTokenFromAuthBody(result.data);
          if (!accessToken) {
            this.dashboardService.toast(
              this.translateService.instant('registration_token_missing'),
              'error',
              { duration: 5000, panelClass: ['mobile-toast'] }
            );
            return;
          }
          const responseData = JSON.parse(atob(accessToken.split('.')[1]));
          const { is_profile_completed: profileCompletedFlag, is_verified: verifiedFlag } =
            readAuthProfileFlags(result.data);
          const isPlayer = responseData?.role_name?.toString()?.toLowerCase() === 'player';
          if (globalThis.window?.localStorage) {
            localStorage.setItem('token', accessToken);
            localStorage.setItem('webToken', accessToken);
            localStorage.setItem("role_id", this.encryptDecryptService.encryptUsingAES256(responseData.role_id.toString()))
            localStorage.setItem("user_role_id", this.encryptDecryptService.encryptUsingAES256(responseData.user_role_id.toString()))
            localStorage.setItem("login_field_value", this.encryptDecryptService.encryptUsingAES256(this.emailValue))
            localStorage.setItem('is_profile_completed', String(profileCompletedFlag));
            localStorage.setItem('is_verified', String(verifiedFlag));
            if (isPlayer) {
              localStorage.setItem('player_role_id', responseData.role_id.toString());
            } else {
              localStorage.removeItem('player_role_id');
            }
          }

          this.dashboardService.toast(this.translateService.instant('registration_successful'), 'success');
          this.commonService.signup_subject.next(false);

          const isProfileCompleted = profileCompletedFlag === true;
          if (isPlayer) {
            this.commonService.is_login_success.next(true);
            this.commonService.login_subject.next(false);
            if (isProfileCompleted) {
              reloadAfterNavigation(this.router.navigate(['/home']));
            } else {
              void this.router.navigate(['/my-profile-dashboard']);
            }
          } else {
            this.commonService.login_subject.next(true);
          }

        },
        error: (result: any) => {
          ; // Verify signup OTP API error
          const errMsg = result.error?.msg;
          if (result.status === 403 || result.error?.code === 403) {
            const sb = this.dashboardService.toast(errMsg, 'error', { duration: 2000 });
            sb.afterDismissed().subscribe(() => {
              this.commonService.signup_subject.next(false);
              this.commonService.login_subject.next(true);
            });
            return;
          }
          this.dashboardService.toast(errMsg, 'error');
        },
        complete: () => undefined,
      });
    }

  }
  fileDetail(file: any, controlname: any, index: any) {
    this.total_fields[index].dummy_value = '';
    const maxSize = 5 * 1024 * 1024; // 5MB
    const minSize = 20 * 1024; // 20KB

    if (file) {
      const extension = file.item(0).name.split('.').pop().toLowerCase(); // Ensure it's in lower case for case insensitive comparison
      const allowedExtensions = this.total_fields[index].field.value_json.data0.split(',');
      if (allowedExtensions.includes(extension)) {
        if (file[0].size > maxSize || file[0].size < minSize) {
          this.dashboardService.toast(this.translateService.instant('file_size_exceeds_limit'), 'error');
        }
        else {
          this._selectedBanner = file.item(0);
          this._uploadImage = this._selectedBanner
          let reader = new FileReader();
          reader.onload = (event: any) => {
            this._selectedBanner = event.target.result;
          };
          reader.readAsDataURL(this._selectedBanner);
          this.uploadBanner(controlname, index);
        }
      }
      else {
        this.dashboardService.toast(
          this.translateService.instant('file_extension_not_allowed', {
            extensions: this.total_fields[index].field.value_json.data0,
          }),
          'error'
        );
      }
    }
  }
  uploadBanner(controlname: any, index: any) {
    this.total_fields[index].dummy_value = '';
    this._showLoader = true
    const formData = new FormData();
    formData.append('file', this._selectedBanner)
    this.dashboardService.fileUpload(formData).subscribe({
      next: (data: any) => {
        this._uploadImage = data.body.url;
        this.total_fields[index].dummy_value = data.body.url;
        this._showLoader = false
        this._formGroupDynamic.controls[controlname].setValue(data.body.url);

      },
      error: (result: any) => {
        this._showLoader = false
      },
      complete: () => undefined,})

  }
  getAcceptType(type: string): string {
    const fileTypes: { [key: string]: string } = {
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      pdf: 'application/pdf'
    };
    const typesArray = type.split(',');
    const mimeTypes = typesArray.map(t => fileTypes[t.trim()]).filter(Boolean);
    return mimeTypes.join(',');
  }
  openImageInNewTab(img: any) {
    if (globalThis.window !== undefined) {
      globalThis.window.open(img, '_blank');
    }
  }
  get_role_parents(roleId: number) {
    this.dashboardService
      .get_role_parents(roleId)
      .pipe()
      .subscribe({
        next: (res: any) => {
          res = res.data; // current data formet is res.data.data ==> concern raised it'll be removed once issue solved
          this.roleParentData = [];
          if (res.code == 200) {
            this.roleParentData = res.data;
          } else {
            this.dashboardService.toast(res.msg, 'error');
          }
        },
        error: (err: any) => {
          console.error(err);
          this.dashboardService.toast(this.translateService.instant('errorMessage'), 'error');
        },
        complete: () => undefined,
      });
  }
  showOverlay(index: any) {
    this.total_fields.forEach((field: any, i: any) => {
      field.show_suggest = (i === index);
    });
  }
  hideOverlay() {
    this.total_fields.forEach((field: any, i: any) => {
      field.show_suggest = false
    });
  }
  check_password() {
    //   return false;
    // } else {
    //   return true
    // }
    return this._formGroupDynamic.controls['Confirm_password'].value === this._formGroupDynamic.controls['password'].value;
  }
  onOtpChange(otp: any) {
    this._currentOTP = otp;
  }
  signUpOtp() {
    this._isSubmit = true;
    if (!this.check_password() || !this._formGroupDynamic.valid) {
      return;
    }

    const parentUserRoles = this.buildParentUserRoles();
    if (parentUserRoles === null) {
      return;
    }

    this.startOtpVerification();
  }

  private buildParentUserRoles(): any[] | null {
    if (!this.roleParentData.length) {
      return [];
    }

    const parentUserRoles = this.roleParentData
      .flatMap((_: any, index: number) => this.selectedParentData[index])
      .filter((element: any) => element !== undefined && element !== null);

    if (!parentUserRoles.length) {
      this.dashboardService.toast(this.translateService.instant('please_select_atleast_one_parent'), 'error');
      return null;
    }

    return parentUserRoles;
  }

  private startOtpVerification(): void {
    clearInterval(this.intervalId);
    this.timer = 180;

    this.authService
      .signUpVerification(
        this.emailValue,
        this.fetched_role_id,
        this.role_field_id,
        this._formGroupDynamic.controls['password'].value,
      )
      .pipe()
      .subscribe({
        next: (res: any) => this.handleOtpVerificationSuccess(res),
        error: (err: any) => this.handleOtpVerificationError(err),
        complete: () => undefined,
      });
  }

  private handleOtpVerificationSuccess(res: any): void {
    if (globalThis.window?.sessionStorage) {
      sessionStorage.setItem('tokenForsignup', res.data.token);
    }

    this.dashboardService.toast(res.msg, 'success');

    if (this.timer <= 0) {
      return;
    }

    this.startOtpCountdown();
    this.activeIndex = 1;
  }

  private handleOtpVerificationError(err: any): void {
    if (err.status === 403) {
      this.showAccountExistsDialog = true;
      return;
    }
    this.dashboardService.toast(err.error?.msg, 'error');
  }

  formatOtpTimer(): string {
    const totalSeconds = Number(this.timer) || 0;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  getOtpTimerProgress(): number {
    const totalSeconds = Number(this.timer) || 0;
    return Math.max(0, Math.min(100, (totalSeconds / this.otpTimerDuration) * 100));
  }

  getMaskedEmail(): string {
    const email = this.emailValue?.trim?.() ?? '';
    if (!email || !email.includes('@')) {
      return '';
    }

    const [localPart, domain] = email.split('@');
    if (!localPart || !domain) {
      return '';
    }

    const visiblePrefix = localPart.slice(0, Math.min(3, localPart.length));
    return `${visiblePrefix}***@${domain}`;
  }

  isOtpCountdownActive(): boolean {
    return this._startCountdown && Number(this.timer) > 0 && !this._isResendingOtp;
  }

  isOtpExpired(): boolean {
    return this._startCountdown && Number(this.timer) <= 0;
  }

  private startOtpCountdown(): void {
    clearInterval(this.intervalId);
    this.timer = this.otpTimerDuration;
    this._startCountdown = true;

    if (typeof window !== 'undefined') {
      this.intervalId = window.setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        }
      }, 1000);
    }
  }

  resendSignupOtp(): void {
    if (this._isResendingOtp) {
      return;
    }

    this._currentOTP = '';

    if (this.ngOtpInput) {
      this.ngOtpInput.setValue('');
    }

    this._isResendingOtp = true;

    this.authService.signUpVerification(
      this.emailValue,
      this.fetched_role_id,
      this.role_field_id,
      this._formGroupDynamic.controls['password'].value
    ).subscribe({
      next: (res: any) => {
        if (typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined') {
          sessionStorage.setItem('tokenForsignup', res.data.token);
        }

        this._isResendingOtp = false;
        this.startOtpCountdown();

        this.dashboardService.toast(res.msg, 'success');
      },
      error: (err: any) => {
        this._isResendingOtp = false;
        if (err.status === 403) {
          this.showAccountExistsDialog = true;
        } else {
          this.dashboardService.toast(err.error?.msg, 'error');
        }
      },
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackByFieldId(index: number, item: any): any {
    return item.id;
  }

  trackById(index: number, item: unknown): string | number {
    if (item != null && typeof item === 'object' && 'id' in item) {
      const id = (item as { id?: string | number }).id;
      if (id != null) return id;
    }
    return index;
  }
}
